/*!
 * Glance Digital Custom JavaScript Programing
 * lance@glance.ca
 *
 */

jQuery(document).ready(function ($) {
  // Velocty Easing
  // ------

  $.Velocity.defaults.easing = "easeInOutQuart";

  // Top Header Nav
  // ------

  if ($(".site-header").length) {
    $(".site-header").switchMenu();
  }

  // Barba
  // ------
  $("#barba-container").initPage();

  if ($("#barba-wrapper").length) {
    $("#barba-wrapper").pageTransitions();
  }

  
});

// ------------------------------------------------------------------------------------------------------------------------------------------------
// PLUGINS

(function ($) {
  // Top Navigation : toggle mobile and desktop
  // ------

  $.fn.switchMenu = function (options) {
    var settings = $.extend(
      {
        breakpoint: "atleast_medium",
      },
      options
    );

    var $top = this;
    var nav_desk = null;
    var nav_mobile = null;

    function switchMenu(obj, media) {
      // Set Desktop Nav
      if (media[settings.breakpoint] || media.fallback) {
        if (nav_mobile != null) {
          nav_mobile.kill();
          nav_mobile = null;
        }
        if (nav_desk == null) {
          nav_desk = $top.desktopMenu();
        }

        // Set Mobile Nav
      } else {
        if (nav_desk != null) {
          nav_desk.kill();
          nav_desk = null;
        }
        if (nav_mobile == null) {
          nav_mobile = $top.mobileMenu();
        }
      }
    }

    $.subscribe("breakpoints", switchMenu);
  };

  // Mobile Menu

  $.fn.mobileMenu = function () {
    var $window = $(window);
    var $body = $("body");
    var $container = this;
    var $nav = $container.find("#primary");
    var $primaryDropdown = this.find(".hamburger");
    var $home = $(".home-panels");
    var open = false;
    var scrollTop = $window.scrollTop();
    var state_1 = false;
    var trigger_1_offset = $home.length ? 90 : 90;

    $nav.velocity("slideUp", { duration: 0, display: "none" });

    $primaryDropdown.on("click", function (e) {
      e.preventDefault();
      if (open) {
        open = false;
        $body.removeClass("header-open");
        $primaryDropdown.removeClass("is-active");
        $nav.velocity("slideUp", { duration: 600, display: "none" });
      } else {
        open = true;
        $body.addClass("header-open");
        $primaryDropdown.addClass("is-active");
        $nav.velocity("slideDown", { duration: 600, display: "block" });
      }
    });

    $nav.on("click", "a", function() {
      $nav.velocity("slideUp", { duration: 200, display: "none" });
    });

    function scrollState() {
      scrollTop = $window.scrollTop();

      // State 1
      if (scrollTop >= trigger_1_offset && !state_1) {
        state_1 = true;
        $body.addClass("scroll-state-1");

        // Clear State
      } else if (scrollTop < trigger_1_offset && state_1) {
        state_1 = false;
        $body.removeClass("scroll-state-1");
      }
    }

    $window.on("scroll.menustate", scrollState);
    scrollState();

    return {
      kill: function () {
        open = false;
        $body.removeClass("header-open");
        $nav.off("click", "a");
        $primaryDropdown.off("click").removeClass("is-active");
        $nav.velocity("slideDown", {
          duration: 0,
          display: "block",
          complete: function () {
            $nav.attr("style", "");
          },
        });
        $body.removeClass("scroll-state-1");
        $window.off("scroll.menustate");
      },
    };
  };

  // Desktop Menu

  $.fn.desktopMenu = function () {
    var $window = $(window);
    var $body = $("body");
    var feature_hidden = true;
    var scrollTop = $window.scrollTop();
    var state_1 = false;
    var state_2 = false;
    var trigger_1_offset = 75; //$home.length ? 75 : 282;
    var trigger_2_offset = 180;

    function scrollState() {
      scrollTop = $window.scrollTop();

      // State 1
      if (scrollTop >= trigger_1_offset && !state_1) {
        state_1 = true;
        $body.addClass("scroll-state-1");

        // Clear State
      } else if (scrollTop < trigger_1_offset && state_1) {
        state_1 = false;
        $body.removeClass("scroll-state-1");
      }

      // State 2
      if (scrollTop >= trigger_2_offset && !state_2) {
        state_2 = true;
        $body.addClass("scroll-state-2");

        // Clear State
      } else if (scrollTop < trigger_1_offset && state_2) {
        state_2 = false;
        $body.removeClass("scroll-state-2");
      }
    }

    $window.on("scroll.menustate", scrollState);
    scrollState();

    // Kill desktop functionality
    // ------

    return {
      kill: function () {
        $body.removeClass("scroll-state-1 scroll-state-2 scroll-state-feature");
        $window.off("scroll.menustate");
      },
    };
  };

  // Init Page Scripts
  // ------

  $.fn.initPage = function () {
    // Reset page after pajax transition
    // ------

    $("html").velocity("scroll", { duration: 0, offset: 0 });

    if ($(".site-header").length) {
      $(".site-header").resetTopNav();
    }

    // Home Template
    if ($(".home-wrapper").length) {
      $("body").addClass("home");
    } else {
      $("body").removeClass("home");
    }

    // Services Template
    if ($(".services-template").length) {
      $("body").addClass("services");
    } else {
      $("body").removeClass("services");
    }
    
    // Team Template
    if ($(".team-template").length) {
      $("body").addClass("team");
    } else {
      $("body").removeClass("team");
    }

    // Careers Template
    if ($(".careers-template").length) {
      $("body").addClass("careers");
    } else {
      $("body").removeClass("careers");
    }
    
    // Contact Template
    if ($(".contact-template").length) {
      $("body").addClass("contact");
    } else {
      $("body").removeClass("contact");
    }
    
    // News Template
    if ($(".news-template").length) {
      $("body").addClass("template-news");
    } else {
      $("body").removeClass("template-news");
    }
    
    // News Single
    if ($(".news-single").length) {
      $("body").addClass("single-news");
    } else {
      $("body").removeClass("single-news");
    }

    // Project Template
    if ($(".projects-template").length) {
      $("body").addClass("template-projects");
    } else {
      $("body").removeClass("template-projects");
    }

    // Single Project
    if ($(".project-single").length) {
      $("body").addClass("single-project");
    } else {
      $("body").removeClass("single-project");
    }
    
    // Single Member
    if ($(".member-single").length) {
      $("body").addClass("single-member");
    } else {
      $("body").removeClass("single-member");
    }

    // Anchor Link Scroll
    // ------

    $("a[href^='#']").scrollto({ offset_lg: 102, offset_sm: 72 });

    // Show in View (inview-animate.js)
    // ------

    if ($(".showOnView.oneTime").length) {
      $(".showOnView.oneTime").showOnView();
    }
    if ($(".showOnView.everyTime").length) {
      $(".showOnView.everyTime").showOnView({ count: "everytime" });
    }

    // Swiper Carousels
    // ------

    $(".home-panels-slider").each(function () {
      if ($(this).find(".swiper-slide").length > 1) {
        $(this).slider({
          // autoplay: false,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          pagination: {
            el: ".swiper-pagination",
            type: "fraction",
          },
        });
      }
    });

    // Expanding List
    // ------

    if ($(".expanding-list").length) {
      $(".expanding-list").expandingList();
    }

    // Mapbox
    // ------

    if ($(".contact-template #map").length) {
      $(".contact-template #map").mapbox();
    }

    // Ajax load more
    // ------

    if ($('.project-list').length) {
      $('.project-list').projectList();
    }
    
    if ($(".team-list #postslist").length) {
      $(".team-list #postslist").ajaxLoad({
        post_type: "c_member",
        template: "parts/loop-member.php",
        orderby: "menu_order",
        auto_load: true,
      });
    }
    if ($(".news-list #postslist").length) {
      $(".news-list #postslist").ajaxLoad({
        base: "/news/",
        filter_style: "pretty",
      });
    }

    // Init Breakpoint Listeners
    // ------------------

    $(this).breakpoints();

  };

  // Page Transitions
  // ------

  $.fn.pageTransitions = function () {
    Barba.Pjax.start();

    $("#barba-container").removeClass("loading");

    var customTransitions = Barba.BaseTransition.extend({
      start: function () {
        // As soon the loading is finished and the old page is faded out, let's fade the new page
        Promise.all([this.newContainerLoading, this.takeOut()]).then(
          this.bringIn.bind(this)
        );
      },

      takeOut: function () {
        // this.oldContainer is the HTMLElement of the old Container
        $(this.oldContainer).addClass("unloading").promise();
      },

      bringIn: function () {
        /**
         * this.newContainer is the HTMLElement of the new Container
         * At this stage newContainer is on the DOM (inside our #barba-container and with visibility: hidden)
         * Please note, newContainer is available just after newContainerLoading is resolved!
         */

        var _this = this;
        var $el = $(this.newContainer);
        var $old = $(this.oldContainer);

        $old
          .addClass("old")
          .delay(300)
          .hide(150, function () {
            // .done() will automatically remove from the DOM the old Container
            _this.done();

            // show new page
            $el.removeClass("loading");

            $el.initPage();
          });

        $el.addClass("loading onviewready").css({
          visibility: "visible",
        });
      },
    });

    //Next step, you have to tell Barba to use the new Transition
    Barba.Pjax.getTransition = function () {
      return customTransitions;
    };
  };

  // Reset TopNav
  // ------

  $.fn.resetTopNav = function () {
    var $body = $("body");
    var $topNavDropdown = this.find(".hamburger");
    var $nav = $("#primary");
    $topNavDropdown.removeClass("is-active");
    $body.removeClass(
      "header-open scroll-state-1 scroll-state-2 scroll-state-feature"
    );
    $nav.attr("style", "");
  };

  // Anchor scroll
  // ------

  $.fn.scrollto = function (options) {
    var settings = $.extend(
      {
        offset_lg: 0,
        offset_sm: 0,
        exclude: "tabbed-link",
      },
      options
    );

    var offset = settings.offset_lg;

    $.subscribe("breakpoints", function (obj, media) {
      offset = media.small ? settings.offset_sm : settings.offset_lg;
    });

    function gotohash(id) {
      if ($("#" + id).length) {
        var $el = $("#" + id);
        var top = id == "top" ? $el.offset().top : $el.offset().top - offset;
        $("html").velocity("scroll", { duration: 900, offset: top });
      }
    }

    this.on("click", function (event) {
      var id = $(this).attr("href").split("#")[1];

      if (!$(this).hasClass(settings.exclude)) {
        if ($("#" + id).length) {
          event.preventDefault();
        }
        gotohash(id);
      }
    });

    if (window.location.hash) {
      gotohash(window.location.hash.split("#")[1]);
    }

    return this;
  };

  // Slides
  // ------

  $.fn.slider = function (options) {
    var settings = $.extend(
      {
        initialize: false,
        speed: 600,
        autoplay: {
          delay: 5000,
          disableOnInteraction: true,
        },
        navigation: false,
        pagination: false,
      },
      options
    );
    var gallery = null;

    var id = this.find(".swiper-container").length
      ? this.find(".swiper-container").attr("id")
      : null;

    if (id) {
      gallery = new Swiper("#" + id, {
        observer: settings.initialize,
        observeParents: settings.initialize,
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 600,
        autoplay: settings.autoplay,
        pagination: settings.pagination,
        navigation: settings.navigation,
      });
    }

    return gallery;
  };

  // Expanding List
  // ------

  $.fn.expandingList = function () {
    this.on("click", ".heading", function () {
      var $li = $(this).parent();
      var $details = $li.find(".details");
      if ($li.hasClass("expanded")) {
        $li.removeClass("expanded");
        $details.velocity("slideUp", { duration: 300, display: "none" });
      } else {
        $li.addClass("expanded");
        $details.velocity("slideDown", { duration: 300, display: "block" });
      }
    });
  };

  // Mapbox
  // ------

  $.fn.mapbox = function () {
    var lat = this.data("lat");
    var lng = this.data("lng");

    mapboxgl.accessToken =
      "pk.eyJ1IjoibGFuY2VvbGl2ZXJjdW1taW5ncyIsImEiOiJEVWoycEE0In0.GxqgSRhKn940IkkJP2SSUA";
    var map = new mapboxgl.Map({
      container: "map",
      style: "mapbox://styles/lanceolivercummings/cke07leks0zu219o5js61nr9v",
      center: [lng, lat], // starting position
      zoom: 14, // starting zoom
    });

    // map.addControl(new mapboxgl.NavigationControl());

    map.on("load", function () {
      map.loadImage(
        glance.templateUrl + "/assets/images/map-marker.png",
        function (error, image) {
          if (error) throw error;
          map.setPadding({ left: 0, bottom: 90 });
          map.addImage("marker", image);
          map.addSource("point", {
            type: "geojson",
            data: {
              type: "FeatureCollection",
              features: [
                {
                  type: "Feature",
                  geometry: {
                    type: "Point",
                    coordinates: [lng, lat],
                  },
                },
              ],
            },
          });
          map.addLayer({
            id: "points",
            type: "symbol",
            source: "point",
            layout: {
              "icon-image": "marker",
              "icon-size": 0.5,
            },
          });
        }
      );
    });
  };

  // Project List
  // ------

  $.fn.projectList = function() {
      var projects_list_init = false;

      function switchprojectlist(obj, media) {
        if (!projects_list_init) {
          projects_list_init = true;
          
          // Set Desktop Nav
          if (media["atleast_medium"] || media.fallback) {
            if ($(".project-list #thumb_postslist").length) {
              $(".project-list #thumb_postslist").ajaxLoadProjects({
                base: "/projects/",
                post_type: "c_project",
                template: "parts/loop-project.php",
                orderby: "menu_order",
                hasimages: "yes",
                sidebar: $(".project-list #postslist").length
                  ? $(".project-list #postslist")
                  : false,
                sidebarhasimages: "no",
                load_on_start: true,
                breakpoints_media: media,
              });
            }

            // Set Mobile Nav
          } else {
            if ($(".project-list #postslist").length) {
              $(".project-list #postslist").ajaxLoad({
                base: "/projects/",
                post_type: "c_project",
                template: "parts/loop-project.php",
                orderby: "menu_order",
                posts_per_page: "mobile_posts_per_page",
                load_on_start: true,
                breakpoints_media: media,
              });
            }
          }
        }
      }
      
      $.subscribe("breakpoints", switchprojectlist);
    }

  // Ajax filter/paginate posts list
  // ------

  $.fn.ajaxLoad = function (options) {
    var settings = $.extend(
      {
        base: false,
        filter_type: "single" /* multi */,
        filter_style: "ugly",
        post_type: "post",
        page_action: "posts_load",
        paginate: "#paginateNav button",
        post: ".ajax-post",
        posts_per_page: "posts_per_page",
        filter_container: ".filter",
        filter: ".taxonomy",
        filter_header: ".taxonomy-header",
        selection_label: ".selection",
        template: "parts/loop-archive.php",
        orderby: "date",
        auto_load: false,
        load_on_start: false,
        breakpoints_media: null,
      },
      options
    );

    var $container = this;
    var $paginateNav = $(settings.paginate);
    var pageIsLoading = false;
    var postsPerPage = this.data(settings.posts_per_page);
    var $filters = $(settings.filter_container + " " + settings.filter);
    var filter = [];
    var filter_str = "";
    var breakpoints_media = settings.breakpoints_media;

    
    $.subscribe("breakpoints", function (obj, media) {
      breakpoints_media = media;
    });
    
    updateFilter();

    $paginateNav.on("click", function (e) {
      e.preventDefault();
      updateFilter();
      ajaxLoad("paginate");
    });

    if (settings.auto_load) {
      $paginateNav.on("inview", function (event, visible, topOrBottomOrBoth) {
        if (visible == true) {
          updateFilter();
          ajaxLoad("paginate");
        }
      });
    }

    if (settings.load_on_start) {
      updateFilter();

      ajaxLoad("paginate", $container, false);
      if (settings.sidebar) {
        ajaxLoad("paginate", settings.sidebar, true);
      }
    }

    function toggleCategoryDropdownState($cat) {
      var unique = $cat.data("taxonomy");
      $cat.toggleClass("open");
      if ($cat.hasClass("open")) {
        $cat.find(".taxonomy-inner").slideDown(300);

        $(document).on("click." + unique, function (e) {
          var $target = $(e.target);
          if (!$target.closest($cat).length) {
            toggleCategoryDropdownState($cat);
          }
        });
      } else {
        $cat.find(".taxonomy-inner").slideUp(300);
        $(document).off("click." + unique);
      }
    }

    if ($filters.length) {
      $filters.on("click", settings.filter_header, function () {
        toggleCategoryDropdownState($(this).parent());
      });

      $filters.on("click", "li", function () {
        var $li = $(this);

        toggleCategoryDropdownState($li.closest(".taxonomy"));

        if (settings.filter_type == "multi") {
          if ($li.data("filter") == "all") {
            $li.addClass("selected").siblings().removeClass("selected");
          } else {
            $li.toggleClass("selected");
            $li.parent().find("li[data-filter='all']").removeClass("selected");
          }
          updateFilter();
          ajaxLoad("filter");
        } else {
          $li.addClass("selected").siblings().removeClass("selected");
          updateFilter();
          ajaxLoad("filter");
        }
      });
    }

    function updateBrowserState(filter) {
      if (settings.base) {
        window.history.replaceState("filter", "Filter", settings.base + filter);
      }
    }

    function updateFilter() {
      filter = [];
      var pos = 0;
      var list_is_filtered = false;

      $filters.each(function () {
        var $this = $(this);
        var taxonomy = $this.data("taxonomy");
        var $label = $this.find(settings.selection_label);
        filter.push({ taxonomy: taxonomy, terms: [] });
        $label.text("");

        if (
          $this.find("li.selected").length ==
          $this.find("li:not([data-filter='all'])").length
        ) {
          $this.find("li").removeClass("selected");
          $this.find("li[data-filter='all']").addClass("selected");
        }

        $this.find("li").each(function () {
          var $li = $(this);
          if ($li.hasClass("selected") && $li.data("filter") != "all") {
            list_is_filtered = true;
            filter[pos].terms.push($li.data("filter"));
            var existing = $label.text();
            var prefix = existing == "" ? "" : ", ";
            $label.text(existing + prefix + $li.text());
          }
        });

        if ($label.text() == "") {
          $label.text("All");
        }

        pos++;
      });

      filter_str = filter.length ? JSON.stringify(filter) : "";

      $.publish("filter_dropdown_apply", [{ filter: filter_str }]);

      if (list_is_filtered) {
        var states = new Array();
        $.each(filter, function (i, obj) {
          if (obj.terms && obj.terms.length && obj.terms[0] != undefined) {
            var pretty_taxonomy = obj.taxonomy;
            if (pretty_taxonomy == "c_project_service") {
              pretty_taxonomy = "service";
            } else if (pretty_taxonomy == "c_project_type") {
              pretty_taxonomy = "type";
            }
            states.push(pretty_taxonomy + "=" + obj.terms.join(","));
          }
        });
        if (states.length == 1 && settings.filter_style == "pretty") {
          updateBrowserState(filter[0].terms[0] + "/");
        } else if (states.length) {
          updateBrowserState("?" + states.join("&"));
        } else {
          updateBrowserState("");
        }
      } else {
        updateBrowserState("");
      }
    }

    function ajaxLoad(action) {
      if (!pageIsLoading) {
        pageIsLoading = true;

        $container.addClass("loading " + action);
        $paginateNav.addClass("loading " + action);

        var offset =
          action == "paginate" ? $container.find(settings.post).length : 0;

        var data = {
          action: settings.page_action,
          type: settings.post_type,
          template: settings.template,
          offset: offset,
          postsPerPage: postsPerPage,
          filter: filter_str,
          orderby: settings.orderby,
        };

        // console.log(data);

        if (action == "filter") {
          $paginateNav.show();
        }

        $.ajax({
          url: glance.ajaxUrl,
          type: "post",
          data: data,
          success: function (result) {
            var $result = $(result);
            var numResults = $result.length;
            var maxPages = $result.first().data("max");
            var hidePaginate =
              numResults < postsPerPage ||
              maxPages * postsPerPage <= offset + numResults;

            if ($result.filter(".showOnView").length) {
              $result.filter(".showOnView").showOnView();
            }

            $.publish("breakpoints", [breakpoints_media]);

            if (action == "paginate") {
              $result.appendTo($container);
            } else {
              $container.html($result);
            }

            if (hidePaginate) $paginateNav.hide();
            pageIsLoading = false;
            $container.removeClass("loading " + action);
            $paginateNav.removeClass("loading " + action);
          },
        });
      }
    }

    return this;
  };


  // Ajax filter/paginate projects list
  // ------

  $.fn.ajaxLoadProjects = function (options) {
    var settings = $.extend(
      {
        base: false,
        filter_type: "single" /* multi */,
        filter_style: "ugly",
        post_type: "post",
        page_action: "projects_load",
        paginate: "#paginateNav button",
        post: ".ajax-post",
        posts_per_page: "posts_per_page",
        filter_container: ".filter",
        filter: ".taxonomy",
        filter_header: ".taxonomy-header",
        selection_label: ".selection",
        template: "parts/loop-archive.php",
        orderby: "date",
        hasimages: 'yes',
        sidebar: null,
        sidebarhasimages: 'no',
        auto_load: false,
        load_on_start = false,
        breakpoints_media = null,
      },
      options
    );

    var $container = this;
    var $paginateNav = $(settings.paginate);
    var $filters = $(settings.filter_container + " " + settings.filter);
    var filter = [];
    var filter_str = "";
    var breakpoints_media = settings.breakpoints_media;
    
    $container.data('page_is_loading', false);
    if (settings.sidebar) {
      settings.sidebar.data('page_is_loading', false);
    }

    $.subscribe("breakpoints", function (obj, media) {
      breakpoints_media = media;
    });

    updateFilter();

    $paginateNav.on("click", function (e) {
      e.preventDefault();
      updateFilter();

      ajaxLoad("paginate", $container, false);
      if (settings.sidebar) {
        ajaxLoad("paginate", settings.sidebar, true);
      }

    });

    if (settings.auto_load) {
      $paginateNav.on("inview", function (event, visible, topOrBottomOrBoth) {
        if (visible == true) {
          updateFilter();

          ajaxLoad("paginate", $container, false);
          if (settings.sidebar) {
            ajaxLoad("paginate", settings.sidebar, true);
          }

        }
      });
    }

    if (settings.load_on_start) {
      updateFilter();

      ajaxLoad("paginate", $container, false);
      if (settings.sidebar) {
        ajaxLoad("paginate", settings.sidebar, true);
      }
    }

    function toggleCategoryDropdownState($cat) {
      var unique = $cat.data("taxonomy");
      $cat.toggleClass("open");
      if ($cat.hasClass("open")) {
        $cat.find(".taxonomy-inner").slideDown(300);

        $(document).on("click." + unique, function (e) {
          var $target = $(e.target);
          if (!$target.closest($cat).length) {
            toggleCategoryDropdownState($cat);
          }
        });
      } else {
        $cat.find(".taxonomy-inner").slideUp(300);
        $(document).off("click." + unique);
      }
    }

    if ($filters.length) {
      $filters.on("click", settings.filter_header, function () {
        toggleCategoryDropdownState($(this).parent());
      });

      $filters.on("click", "li", function () {
        var $li = $(this);

        toggleCategoryDropdownState($li.closest(".taxonomy"));

        if (settings.filter_type == "multi") {
          if ($li.data("filter") == "all") {
            $li.addClass("selected").siblings().removeClass("selected");
          } else {
            $li.toggleClass("selected");
            $li.parent().find("li[data-filter='all']").removeClass("selected");
          }
          updateFilter();

          ajaxLoad("filter", $container, false);
          if (settings.sidebar) {
            ajaxLoad("filter", settings.sidebar, true);
          }

        } else {
          $li.addClass("selected").siblings().removeClass("selected");
          updateFilter();

          ajaxLoad("filter", $container, false);
          if (settings.sidebar) {
            ajaxLoad("filter", settings.sidebar, true);
          }

        }
      });
    }

    function updateBrowserState(filter) {
      if (settings.base) {
        window.history.replaceState("filter", "Filter", settings.base + filter);
      }
    }

    function updateFilter() {
      filter = [];
      var pos = 0;
      var list_is_filtered = false;

      $filters.each(function () {
        var $this = $(this);
        var taxonomy = $this.data("taxonomy");
        var $label = $this.find(settings.selection_label);
        filter.push({ taxonomy: taxonomy, terms: [] });
        $label.text("");

        if (
          $this.find("li.selected").length ==
          $this.find("li:not([data-filter='all'])").length
        ) {
          $this.find("li").removeClass("selected");
          $this.find("li[data-filter='all']").addClass("selected");
        }

        $this.find("li").each(function () {
          var $li = $(this);
          if ($li.hasClass("selected") && $li.data("filter") != "all") {
            list_is_filtered = true;
            filter[pos].terms.push($li.data("filter"));
            var existing = $label.text();
            var prefix = existing == "" ? "" : ", ";
            $label.text(existing + prefix + $li.text());
          }
        });

        if ($label.text() == "") {
          $label.text("All");
        }

        pos++;
      });

      filter_str = filter.length ? JSON.stringify(filter) : "";

      $.publish("filter_dropdown_apply", [{ filter: filter_str }]);

      if (list_is_filtered) {
        var states = new Array();
        $.each(filter, function (i, obj) {
          if (obj.terms && obj.terms.length && obj.terms[0] != undefined) {
            var pretty_taxonomy = obj.taxonomy;
            if (pretty_taxonomy == "c_project_service") {
              pretty_taxonomy = "service";
            } else if (pretty_taxonomy == "c_project_type") {
              pretty_taxonomy = "type";
            }
            states.push(pretty_taxonomy + "=" + obj.terms.join(","));
          }
        });
        if (states.length == 1 && settings.filter_style == "pretty") {
          updateBrowserState(filter[0].terms[0] + "/");
        } else if (states.length) {
          updateBrowserState("?" + states.join("&"));
        } else {
          updateBrowserState("");
        }
      } else {
        updateBrowserState("");
      }
    }

    function ajaxLoad(action, target, sidebar) {

      if (!target.data('page_is_loading')) {

        target.data('page_is_loading', true);
        target.data(
          "offset",
          action == "paginate" ? target.find(settings.post).length : 0
        );

        target.addClass("loading " + action);
        $paginateNav.addClass("loading " + action);

        var data = {
          action: settings.page_action,
          type: settings.post_type,
          template: settings.template,
          offset: target.data('offset'),
          postsPerPage: target.data(settings.posts_per_page),
          filter: filter_str,
          orderby: settings.orderby,
          hasimages: sidebar ? settings.sidebarhasimages : settings.hasimages,
        };

        // console.log(data);

        if (action == "filter") {
          $paginateNav.show();
        }

        $.ajax({
          url: glance.ajaxUrl,
          type: "post",
          data: data,
          success: function (result) {
            var $result = $(result);
            target.data('num_results', $result.length);
            target.data('max_pages', $result.first().data("max"));
            var hidePaginate = allPostsLoaded();

            if ($result.filter(".showOnView").length) {
              $result.filter(".showOnView").showOnView();
            }

            $.publish("breakpoints", [breakpoints_media]);

            if (action == "paginate") {
              $result.appendTo(target);
            } else {
              target.html($result);
            }

            if (hidePaginate) $paginateNav.hide();
            target.data('page_is_loading', false);
            target.removeClass("loading " + action);
            $paginateNav.removeClass("loading " + action);
          },
        });
      }
    }

    function allPostsLoaded() {
      var num_results =
        typeof $container.data("num_results") !== "undefined" &&
        $container.data("num_results") !== false &&
        $container.data("num_results") !== ""
          ? $container.data("num_results")
          : false;
      var max_pages =
        typeof $container.data("max_pages") !== "undefined" &&
        $container.data("max_pages") !== false &&
        $container.data("max_pages") !== ""
          ? $container.data("max_pages")
          : false;
      var posts_per_page =
        typeof $container.data("posts_per_page") !== "undefined" &&
        $container.data("posts_per_page") !== false &&
        $container.data("posts_per_page") !== ""
          ? $container.data("posts_per_page")
          : false;
      var offset =
        typeof $container.data("offset") !== "undefined" &&
        $container.data("offset") !== false &&
        $container.data("offset") !== ""
          ? $container.data("offset")
          : false;

      if (settings.sidebar) {
        var sidebar_num_results =
          typeof settings.sidebar.data("num_results") !== "undefined" &&
          settings.sidebar.data("num_results") !== false &&
          settings.sidebar.data("num_results") !== ""
            ? settings.sidebar.data("num_results")
            : false;
        var sidebar_max_pages =
          typeof settings.sidebar.data("max_pages") !== "undefined" &&
          settings.sidebar.data("max_pages") !== false &&
          settings.sidebar.data("max_pages") !== ""
            ? settings.sidebar.data("max_pages")
            : false;
        var sidebar_posts_per_page =
          typeof settings.sidebar.data("posts_per_page") !== "undefined" &&
          settings.sidebar.data("posts_per_page") !== false &&
          settings.sidebar.data("posts_per_page") !== ""
            ? settings.sidebar.data("posts_per_page")
            : false;
        var sidebar_offset =
          typeof settings.sidebar.data("offset") !== "undefined" &&
          settings.sidebar.data("offset") !== false &&
          settings.sidebar.data("offset") !== ""
            ? settings.sidebar.data("offset")
            : false;

        if (!max_pages || !sidebar_max_pages ) {
          return false;
        } else {
          var done = num_results < posts_per_page || max_pages * posts_per_page <= offset + num_results;
          var sidebar_done = sidebar_num_results < sidebar_posts_per_page || sidebar_max_pages * sidebar_posts_per_page <= sidebar_offset + sidebar_num_results;
          return done && sidebar_done;
        }

      } else {

        return num_results < posts_per_page || max_pages * posts_per_page <= offset + num_results;
      }

    }

    return this;
  };

  // Utilities
  // ------

  var aboveView = function (element) {
    return (
      $(window).scrollTop() >= element.offset().top + element.outerHeight()
    );
  };

  var belowFocus = function (element, focusMultipliers) {
    return (
      $(window).height() + $(window).scrollTop() <
      element.offset().top + $(window).height() * focusMultipliers
    );
  };

  var isInFocus = function (element, focusMultipliers) {
    return (
      aboveView(element) != true &&
      belowFocus(element, focusMultipliers) != true
    );
  };
})(jQuery);
